import ApplicationsSelf from '../components/ApplicationsSelf';
export default ApplicationsSelf; 